import type { UserTagsById } from '../../api/queries/usersTags.js';
import type { UserTableV2Row } from './datasource.js';

type UserId = UserTableV2Row['id'];

export type SetUserUpdating = (userId: UserId, isUpdating: boolean) => void;

export type UserTableV2GridContext = {
  updatingUserIds: ReadonlySet<UserId>;
  setUserUpdating: SetUserUpdating;
  isReadonlyPermission: boolean;
  onEditClick: (user: UserTableV2Row) => void;
  onRemoveClick: (user: UserTableV2Row) => void;
  userTagsById: UserTagsById;
  isUserTagsLoading: boolean;
};

export const isUserUpdating = (
  context: UserTableV2GridContext | undefined,
  userId: UserId | undefined,
) => userId !== undefined && context?.updatingUserIds.has(userId) === true;

export const getUserTags = (
  context: UserTableV2GridContext | undefined,
  userId: UserId | undefined,
) => (userId === undefined ? undefined : context?.userTagsById.get(userId));
